import { Stack, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';

import { type InvoiceFooterField, useLoadInvoiceFooter } from '../api';
import classes from './FooterItem.module.css';

const Placeholder = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation();

  return (
    <div className={classes.item} data-empty onClick={onClick}>
      <Text size="sm" c="dimmed">
        {t(i18nKeys.SETTINGS.INVOICING.FOOTER.CLICK_TO_EDIT)}
      </Text>
    </div>
  );
};

interface InvoiceItemProps {
  item: InvoiceFooterField;
  onClickEdit: () => void;
}

export const FooterItem = ({ item, onClickEdit }: InvoiceItemProps) => {
  const { invoiceFooter } = useLoadInvoiceFooter();

  if (invoiceFooter == null) return null;

  if (item == null) {
    return <Placeholder onClick={onClickEdit} />;
  }

  if (typeof item === 'string') {
    return (
      <div className={classes.item} onClick={onClickEdit}>
        <Text size="sm">{item}</Text>
      </div>
    );
  }

  const displayName = invoiceFooter.availableFields.find(el => el.field === item.field)?.name;

  return (
    <div className={classes.item} onClick={onClickEdit}>
      <Stack gap={2}>
        <Text size="xs" c="dimmed">
          {displayName}
        </Text>
        <Text size="sm">{item.content}</Text>
      </Stack>
    </div>
  );
};
